module.exports = __webpack_public_path__ + "img/vi_vn.a0e23328.svg";